import { useState } from "react";
import { X, Plus } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "../../lib/api";
import { YEAR_PRESETS, PRESET_LABELS } from "../../lib/yearPresets";

export function AddChildModal({ onClose, onAdded }) {
  const [childForm, setChildForm] = useState({ name: "", year_system: "scottish", year_group: "" });
  const [adding, setAdding] = useState(false);

  const addChild = async () => {
    if (!childForm.name.trim()) return toast.error("Add their name");
    setAdding(true);
    try {
      const { data: nc } = await api.post("/parent/children", {
        name: childForm.name, year_group: childForm.year_group, year_system: childForm.year_system,
      });
      toast.success(`${nc.name} added`);
      onAdded(nc);
    } catch (e) {
      toast.error(apiError(e));
      setAdding(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-zinc-900/50 flex items-center justify-center p-4" data-testid="add-child-modal">
      <div className="nb-card p-6 w-full max-w-md bg-white">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-display font-bold text-xl">Add a child</h3>
          <button onClick={onClose} data-testid="add-child-close" className="p-1.5 rounded-lg border-2 border-zinc-900 bg-white hover:bg-zinc-100"><X className="w-4 h-4" /></button>
        </div>
        <div className="space-y-4">
          <div>
            <label className="nb-label" htmlFor="add-child-name">Child's name</label>
            <input id="add-child-name" className="nb-input mt-2" data-testid="add-child-name" placeholder="e.g. Cameron"
              value={childForm.name} onChange={(e) => setChildForm({ ...childForm, name: e.target.value })} maxLength={60} />
          </div>
          <div>
            <label className="nb-label" htmlFor="add-child-system">Year group naming</label>
            <select id="add-child-system" className="nb-input mt-2" data-testid="add-child-system"
              value={childForm.year_system} onChange={(e) => setChildForm({ ...childForm, year_system: e.target.value, year_group: "" })}>
              {Object.entries(PRESET_LABELS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
            </select>
          </div>
          <div>
            <label className="nb-label" htmlFor="add-child-year">Current year group (optional)</label>
            <select id="add-child-year" className="nb-input mt-2" data-testid="add-child-year"
              value={childForm.year_group} onChange={(e) => setChildForm({ ...childForm, year_group: e.target.value })}>
              <option value="">Choose…</option>
              {YEAR_PRESETS[childForm.year_system].map((y) => <option key={y} value={y}>{y}</option>)}
            </select>
          </div>
          <button onClick={addChild} disabled={adding} data-testid="add-child-submit" className="nb-btn w-full bg-[#F9A8D4] py-2.5">
            <Plus className="w-4 h-4" /> {adding ? "Adding…" : "Add child"}
          </button>
        </div>
      </div>
    </div>
  );
}
